import { NavLink } from "react-router-dom";
import { cn } from "@/lib/utils";

interface GenieKnowledgeTabsProps {
  genieId: string;
  /** Shown beside "Documents" once this Genie has made some. */
  documentCount?: number;
  className?: string;
}

const TAB =
  "relative -mb-px border-b-2 px-1 pb-3 text-sm font-semibold transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-genie-primary";

/**
 * The two halves of a Genie's knowledge: what it reads, and what it produces.
 *
 * They are one area because branded documents are built *from* the knowledge
 * base — splitting them into unrelated corners of the app is what made the old
 * modal on the Genie detail page feel bolted on.
 */
export const GenieKnowledgeTabs = ({
  genieId,
  documentCount,
  className,
}: GenieKnowledgeTabsProps) => (
  <nav className={cn("mb-6 flex items-center gap-6 border-b border-gray-200", className)}>
    <NavLink
      end
      to={`/genie-hub/knowledge-base/${genieId}`}
      className={({ isActive }) =>
        cn(TAB, isActive ? "border-genie-primary text-gray-900" : "border-transparent text-gray-500 hover:text-gray-800")
      }
    >
      Sources
    </NavLink>
    <NavLink
      to={`/genie-hub/knowledge-base/${genieId}/documents`}
      className={({ isActive }) =>
        cn(TAB, isActive ? "border-genie-primary text-gray-900" : "border-transparent text-gray-500 hover:text-gray-800")
      }
    >
      Documents
      {documentCount ? (
        <span className="ml-1.5 rounded-full bg-gray-100 px-1.5 py-0.5 text-[10px] font-bold text-gray-500">
          {documentCount}
        </span>
      ) : null}
    </NavLink>
  </nav>
);

export default GenieKnowledgeTabs;
